export default "__VITE_PUBLIC_ASSET__6ad28d9d__"